<template>
  <div :class="[windowWidth > 700 ? 'normal' : 'cell']">
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker
          v-if="isStart"
          :from="$moment(sdInput).utc().format('X')"
          @customFunction="setDate"
        ></world-date-picker>
        <world-date-picker
          v-else
          :from="$moment(edInput).utc().format('X')"
          @customFunction="setDate"
        ></world-date-picker>
      </div>
    </wg-modal>
    <!-- Nome -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
        {{ $anm22.strLang(lang, "Event name", "Nome evento") }}
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <input
          :disabled="!canEdit"
          class="anm22-calendar-input-text"
          style="max-width: 100%"
          type="text"
          v-model="event.name"
          :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
        />
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <!-- Scelta calendario aziendale -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
        {{ $anm22.strLang(lang, "Calendar", "Calendario") }}
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <select
          :disabled="!canEdit"
          class="com-anm22-app-select"
          style="max-width: 100%"
          v-model="event.work"
        >
          <option value="0">
            {{ $anm22.strLang(lang, "Private", "Privato") }}
          </option>
          <option
            v-for="(obj, index) in works"
            :key="'work-' + index"
            :value="obj.idWorldWork"
          >
            {{ obj.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <!-- Data / Ora -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 labelDateTo anm22-calendar-label-tiny-inline"
      >
        {{ $anm22.strLang(lang, "Start", "Inizio") }}
      </div>
      <div class="wg-col wg-xs-7 wg-sm-5">
        <div
          v-if="canEdit"
          @click="openDatePicker(true)"
          class="input-date-picker-label"
        >
          {{ startDateInput != "" ? startDateInput : "-" }}
        </div>
        <div v-if="!canEdit" class="input-date-picker-label">
          {{ startDateInput != "" ? startDateInput : "-" }}
        </div>
      </div>
      <div class="wg-col wg-xs-5 wg-sm-3">
        <input :disabled="!canEdit" type="time" v-model="startTimeInput" />
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 labelDateTo anm22-calendar-label-tiny-inline"
      >
        {{ $anm22.strLang(lang, "End", "Fine") }}
      </div>
      <div class="wg-col wg-xs-7 wg-sm-5">
        <div
          v-if="canEdit"
          @click="openDatePicker(false)"
          class="input-date-picker-label"
        >
          {{ endDateInput != "" ? endDateInput : "-" }}
        </div>
        <div v-if="!canEdit" class="input-date-picker-label">
          {{ endDateInput != "" ? endDateInput : "-" }}
        </div>
      </div>
      <div class="wg-col wg-xs-5 wg-sm-3">
        <input :disabled="!canEdit" type="time" v-model="endTimeInput" />
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <!-- Timezone -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
        {{ $anm22.strLang(lang, "Timezone", "Fuso orario") }}
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <select
          :disabled="!canEdit"
          class="com-anm22-app-select"
          style="max-width: 100%"
          v-model="event.timezone"
        >
          <option :value="null" disabled hidden>
            {{ $anm22.strLang(lang, "Select", "Seleziona") }}
          </option>
          <option
            v-for="(obj, key, index) in $anm22.tableClasses
              .worldTimezone()
              .getAll()"
            :key="'timezone-' + index"
            :value="key"
          >
            {{ obj[lang] }}
          </option>
        </select>
      </div>
    </div>
    <!-- Luogo -->
    <template v-if="event.type != 6">
      <div class="vertical-height-div" style="height: 20px"></div>
      <place v-model="eventPlace" :editMode="canEdit"></place>
    </template>
    <!-- Note -->
    <div class="vertical-height-div" style="height: 10px"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline">
        {{ $anm22.strLang(lang, "Description", "Descrizione") }}
      </div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <div style="position: relative">
          <textarea
            :disabled="!canEdit"
            style="margin: 0; max-width: 100%; padding-bottom: 53px"
            v-model="event.notes"
            rows="3"
          ></textarea>
          <template v-if="event.idWorldEvent && event.links.length == 0">
            <div style="position: absolute; bottom: 0">
              <div class="icon-div desc-box">
                <img
                  class="com-anm22-app-img-fixed-height-l"
                  style="padding: 5px; height: 100%"
                  :title="$anm22.strLang(lang, 'Add link', 'Aggiungi link')"
                  :src="$anm22.icons.getWorldIcon('link')"
                  @click="$emit('showLinkModal')"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- Pulsanti -->
    <div class="vertical-height-div" style="height: 10px"></div>
    <input
      v-if="canEdit"
      type="button"
      class="com-anm22-input-button"
      @click="save"
      :value="$anm22.strLang(lang, 'Save', 'Salva')"
    />
    <img
      v-if="showSaved"
      class="cont-tick"
      :src="$anm22.icons.getWorldIcon('tick')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldDatePicker from "../../../../../../world/spa/components/WorldDatePicker.vue";
import Place from "../EventPlace.vue";

export default {
  props: {
    eventRef: Object,
    showSaved: Boolean,
  },
  components: {
    WorldDatePicker,
    Place,
  },
  data() {
    return {
      event: { ...this.eventRef },
      manualPlace: false,
      values: [],
      filters: [],
      isStart: false,
      openPicker: false,
      noResults: false,
      // Variabili input
      sd: "",
      sdInput: "",
      st: "",
      stInput: "",
      ed: "",
      edInput: "",
      et: "",
      etInput: "",
    };
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      mapsAPIKey: (state) => state.config.mapsAPIKey,
      lang: (state) => state.lang,
    }),
    works() {
      return this.$store.getters["works/getAll"];
    },
    eventPlace: {
      get() {
        return {
          name: this.event.placeName,
          street: this.event.placeStreet,
          number: this.event.placeNumber,
          city: this.event.placeCity,
          zip: this.event.placeZip,
          state: this.event.placeState,
          country: this.event.placeCountry,
        };
      },
      set: function (newPlace) {
        this.event.placeName = newPlace.name;
        this.event.placeStreet = newPlace.street;
        this.event.placeNumber = newPlace.number;
        this.event.placeCity = newPlace.city;
        this.event.placeZip = newPlace.zip;
        this.event.placeState = newPlace.state;
        this.event.placeCountry = newPlace.country;
      },
    },
    canEdit() {
      const invites = this.$store.getters["invites/getByEvent"](
        this.event.idWorldEvent
      );
      const admin = invites.find(
        (i) => i.user === this.user.idWorldUser && i.permission == 1
      );
      return !this.event.idWorldEvent || (admin && admin !== -1);
    },
    startDate: {
      get() {
        return this.sd;
      },
      set: function (newDate) {
        this.sd = newDate;
        this.checkInputFields("f");
      },
    },
    startTime: {
      get() {
        return this.st;
      },
      set: _.debounce(function (newTime) {
        this.st = newTime;
        this.checkInputFields("f");
      }, 1000),
    },
    startDateInput: {
      get() {
        return this.sd;
      },
      set: function (newDate) {
        // Controllo che sia nel formato giusto
        this.sdInput = this.$anm22.parseInputDate(newDate);
        // debounced
        this.startDate = this.sdInput;
      },
    },
    startTimeInput: {
      get() {
        return this.st;
      },
      set: function (newTime) {
        // Controllo che sia nel formato giusto
        this.stInput = this.$anm22.parseInputTime(newTime);
        this.startTime = this.stInput;
      },
    },
    endDate: {
      get() {
        return this.ed;
      },
      set: function (newDate) {
        this.ed = newDate;
        this.checkInputFields("e");
      },
    },
    endTime: {
      get() {
        return this.et;
      },
      set: _.debounce(function (newTime) {
        this.et = newTime;
        this.checkInputFields("e");
      }, 1000),
    },
    endDateInput: {
      get() {
        return this.ed;
      },
      set: function (newDate) {
        // Controllo che sia nel formato giusto
        this.edInput = this.$anm22.parseInputDate(newDate);
        this.endDate = this.edInput;
      },
    },
    endTimeInput: {
      get() {
        return this.et;
      },
      set: function (newTime) {
        // Controllo che sia nel formato giusto
        this.etInput = this.$anm22.parseInputTime(newTime);
        this.endTime = this.etInput;
      },
    },
    // startDate: {
    //   get() {
    //     return this.$moment
    //       .unix(this.event.startTimestamp)
    //       .format("YYYY-MM-DD");
    //   },
    //   set: _.debounce(function(newVal) {
    //     this.event.startTimestamp = Number(
    //       this.$moment(newVal + " " + this.startTime).unix()
    //     );
    //     this.checkInputFields("s");
    //   }, 1000)
    // },
    // startTime: {
    //   get() {
    //     return this.$moment.unix(this.event.startTimestamp).format("HH:mm");
    //   },
    //   set: _.debounce(function(newTime) {
    //     this.event.startTimestamp = Number(
    //       this.$moment(this.startDate + " " + newTime).unix()
    //     );
    //     this.checkInputFields("s");
    //   }, 1000)
    // },
    // endDate: {
    //   get() {
    //     return this.$moment.unix(this.event.endTimestamp).format("YYYY-MM-DD");
    //   },
    //   set: _.debounce(function(newValEnd) {
    //     this.event.endTimestamp = Number(
    //       this.$moment(newValEnd + " " + this.endTime).unix()
    //     );
    //     this.checkInputFields("e");
    //   }, 1000)
    // },
    // endTime: {
    //   get() {
    //     return this.$moment.unix(this.event.endTimestamp).format("HH:mm");
    //   },
    //   set: _.debounce(function(newTime) {
    //     this.event.endTimestamp = Number(
    //       this.$moment(this.endDate + " " + newTime).unix()
    //     );
    //     this.checkInputFields("e");
    //   }, 1000)
    // },
  },
  methods: {
    openDatePicker(isStart) {
      this.isStart = isStart;
      this.openPicker = true;
    },
    checkInputFields(input) {
      console.log("ciao");
      const errors = { start: null, end: null };
      const start = this.$moment(this.sd + " " + this.st);
      const end = this.$moment(this.ed + " " + this.et);
      if (!start.isValid()) {
        errors.start = { text: "" };
        this.$emit("setErrors", errors);
        return;
        // this.$set(this.errors, 'start', { text: '' });
        // return;
      }
      if (!end.isValid()) {
        errors.end = { text: "" };
        this.$emit("setErrors", errors);
        return;
        // this.$set(this.errors, 'end', { text: '' });
        // return;
      }
      if (end.unix() < start.unix()) {
        if (input === "f") {
          this.ed = this.edInput = this.sd;
          this.et = this.etInput = this.st;
        } else {
          this.sd = this.sdInput = this.ed;
          this.st = this.stInput = this.et;
        }
      }
    },
    setDate(newDate) {
      if (this.isStart) {
        this.sdInput = this.$anm22.parseInputDate(newDate);
        this.startDate = this.sdInput;
      } else {
        this.edInput = this.$anm22.parseInputDate(newDate);
        this.endDate = this.edInput;
      }
      this.openPicker = false;
    },
    save() {
      this.sd = this.sdInput || this.sd;
      this.st = this.stInput || this.st;
      this.ed = this.edInput || this.ed;
      this.et = this.etInput || this.et;
      this.checkInputFields("f");
      // Collego timezone e date
      this.event.startTimestamp = this.$moment
        .tz(this.sd + " " + this.st, this.event.timezone)
        .unix();
      this.event.endTimestamp = this.$moment
        .tz(this.ed + " " + this.et, this.event.timezone)
        .unix();
      this.$emit("save", this.event);
    },
    // setStart(newDate) {
    //   let time = this.$moment.unix(this.event.startTimestamp).format("HH:mm");
    //   let date = newDate + " " + time;
    //   let ts = this.$moment(date).unix();
    //   if (isNaN(ts)) {
    //     this.event.startTimestamp = "";
    //   } else if (ts) {
    //     this.event.startTimestamp = ts;
    //   }
    //   this.checkInputFields("s");
    //   this.openPicker = false;
    // },
    // setEnd(newDate) {
    //   let time = this.$moment.unix(this.event.endTimestamp).format("HH:mm");
    //   let date = newDate + " " + time;
    //   let ts = this.$moment(date).unix();
    //   if (isNaN(ts)) {
    //     this.event.endTimestamp = "";
    //   } else if (ts) {
    //     this.event.endTimestamp = ts;
    //   }
    //   this.checkInputFields("e");
    //   this.openPicker = false;
    // },
    addPlace(idPlace) {
      this.values = [];
      this.$http
        .post(
          "events/getplacedata",
          {
            idPlace,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.event.contactPlace = response.data.place.idContactsPlace;
          this.event.placeName = response.data.place.name;
          this.event.placeStreet = response.data.place.addressStreet;
          this.event.placeNumber = response.data.place.addressNumber;
          this.event.placeCity = response.data.place.addressCity;
          this.event.placeZip = response.data.place.addressZip;
          this.event.placeState = response.data.place.addressState;
          this.event.placeCountry = response.data.place.addressCountry;
          this.manual = true;
        })
        .catch((error) => {});
    },
  },
  created() {
    this.sd = this.sdInput = this.$moment
      .unix(this.event.startTimestamp)
      .tz(this.event.timezone)
      .format("YYYY-MM-DD");
    this.st = this.stInput = this.$moment
      .unix(this.event.startTimestamp)
      .tz(this.event.timezone)
      .format("HH:mm");
    this.ed = this.edInput = this.$moment
      .unix(this.event.endTimestamp)
      .tz(this.event.timezone)
      .format("YYYY-MM-DD");
    this.et = this.etInput = this.$moment
      .unix(this.event.endTimestamp)
      .tz(this.event.timezone)
      .format("HH:mm");
  },
};
</script>

<style lang="scss" scoped>
.cont-tick {
  display: inline-block;
  height: auto;
  margin-left: 11px;
  width: 24px;
}
.normal {
  width: 440px;
}
.cell {
  width: calc(80vw - 20px);
}
.place-hint {
  min-height: 56px;
  font-weight: bold;
  margin-left: 4px;
  width: 100px;
  font-size: 13px;
  border-radius: 8px;
  border: 2px solid #eee;
  cursor: pointer;
  display: inline-block;
  padding: 5px;
}
.icon-div {
  border-radius: 30px;
  width: 50px;
  height: 50px;
  border: 1px solid #9999;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 5px;
  margin: 5px 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.icon-div.desc-box {
  border: none;
  width: 40px;
  height: 40px;
  padding: 2px;
  background-color: #eee;
  &:hover {
    background-color: #ddd;
  }
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
</style>
